module.exports = __webpack_public_path__ + "platform/static/media/logout.c25bb94f.svg";